import { Button, Radio, RadioChangeEvent, Space } from 'antd';

import { ShippingOption } from 'Consts';

import './styles.scss';

interface Props {
  onChange: (e: RadioChangeEvent) => void;
  option: ShippingOption;
  onFindClick: () => void;
}

export function ShippingOptions({ onChange, option, onFindClick }: Props) {
  return (
    <Radio.Group value={option} onChange={onChange}>
      <Space direction="vertical">
        <Radio value={ShippingOption.Home}>
          Delivery <Button onClick={onFindClick}>Choose your Delivery Option</Button>
        </Radio>
        <Radio value={ShippingOption.Self}>Free in Store Pickup</Radio>
      </Space>
    </Radio.Group>
  );
}
